<script setup lang="ts">
import { ref } from 'vue'
import { twMerge } from 'tailwind-merge'
import CrossCircleIcon from '@/components/icons/CrossCircleIcon.vue'

defineProps<{
  placeholder?: string
  hasError?: boolean,
  disabled?: boolean
}>()

const emit = defineEmits<{
  (e: 'focus'): void
  (e: 'blur'): void
}>()

const model = defineModel<string>()

const input = ref<HTMLInputElement | null>(null)
const isInputFocused = ref(false)

function resetAnswer(e: Event) {
  e.preventDefault()
  if (model.value?.length) {
    model.value = ''
  } else {
    input.value?.blur()
  }
}

</script>
<template>
  <div
    :class="
      twMerge(
        'flex w-full items-center overflow-hidden border border-white/[38%] px-2 py-3 rounded-xl bg-white/[12%] text-white',
        isInputFocused && 'border-white/[67%] bg-white/[24%]',
        hasError && 'border-red-danger bg-red-danger/[12%]',
        disabled && 'pointer-events-none'
      )
    "
  >
    <input
      ref="input"
      v-model="model"
      :placeholder="placeholder"
      required
      :class="
        twMerge(
          'w-full flex-1 text-white/100 block border-0 text-sm font-medium placeholder:text-white focus:border-0 focus:outline-0 focus:ring-0 bg-transparent px-2',
        )
      "
      @focus="isInputFocused = true; emit('focus')"
      @blur="isInputFocused = false; emit('blur')"
    >
    <div
      v-if="isInputFocused"
      class="size-5 cursor-pointer"
      @pointerdown="resetAnswer"
    >
      <CrossCircleIcon class="w-full h-full" />
    </div>
  </div>
</template>
